export default {
  label: {
    currentDirection: "期間",
    headquarter: "本部署名",
    creator: "設定者",
    approver: "承認者",
    typeTargetSetting: "被評価者",
    cpTableName: "評価テーブル名",
    processTarget: "プロセス目標状態",
    targetResult: "数値目標実績入力状態",
    resultAchievement: "実績・達成度入力状態",
    targetName: "目標",
    targetNamePlaceholder: "評価項目入力",
    targetRequired: "必須",
    targetWeight: "ウェイト",
    targetUnit: "単位",
    targetFormula: "計算式",
    targetCalculation: "計算要否",
    targetOrder: "降順・昇順",
    targetDetailName: "項目",
    expectation: "目標",
    accomplished: "実績",

    member: "社員",
    memberId: "社員番号",
    memberName: "名前",
    headName: "本部署",
    departmentName: "部署",
    teamName: "チーム",
    period: "期間",
    role: "役職",
    permissionName: "役職",
    cpTable: "評価テーブル",
    memberQuery: "社員指名・ID",
    processStatus: "プロセス目標の状態",

    selectAll: "すべて",
    others: "others",
    itemsSelected: "件選択",
    month: "月",
    year: "年",
    file: "ファイル",
    typeMemberTransfer: "異動後の評価テーブルがないメンバー一覧表示",

    oldDepart: "旧部署",
    olePermission: "旧役職",
    newDepart: "新部署",
    newPermission: "役職",
    cpStatus: "移動状態",

    historyType: "評価履歴の種類",
    periodYear: "年度",
    periodMonth: "月度",
    periodDay: "移動日",
  },
  btn: {
    addCpTable: "評価テーブル追加",
    deleteCpTable: "評価テーブル削除",
    clear: "クリア",
    cancel: "キャンセル",
    save: "保存",
    submit: "申請",
    approve: "承認",
    reject: "差し戻し",
    back: "戻る",
    settingMembers: "メンバー設定",
    settingTargetMember: "設定",
    add: "保存",
    add2: "追加",
    add3: "作成",
    delete: "削除",
    ok: "保存",
    addSampleTarget: "評価項目追加",
    detail: "詳細",
    move: "移動",
    rollback: "取り消す",
    filter: "絞り込み",
    historyDetail: "履歴",
    selectFile: "ファイル選択",
    upload: "アップロード",
  },
  title: {
    addCpTable: "評価テーブル追加",
    infoCpTable: "基本情報",
    targetSettings: "評価目標設定",
    personalSettings: "評価対象（個人目標設定）",
    addUsersToCpTable: "メンバー設定",
    confirmDeleteCpTable: "評価テーブル削除の確認",
    targetSettingOfUser: "個人目標設定",
    addMemberToCpTable: "新部署の評価テーブル指定",
    historyPage: "評価履歴閲覧機能",
    dataCollection: "データ集計",
    dataCollectionDetail: "データ集計詳細",
  },
};
